
import { officialUrl, openPlatformUrl, onlineServiceUrl } from './api';

import secondIcon01 from '@/assets/images/header/secondIcon01.png'
import secondIcon02 from '@/assets/images/header/secondIcon02.png'
import secondIcon03 from '@/assets/images/header/secondIcon03.png'
import secondIcon04 from '@/assets/images/header/secondIcon04.png'
import secondIcon05 from '@/assets/images/header/secondIcon05.png'
import secondIcon06 from '@/assets/images/header/secondIcon06.png'

import threeIcon01 from '@/assets/images/header/threeIcon01.png'
import threeIcon02 from '@/assets/images/header/threeIcon02.png'
import threeIcon03 from '@/assets/images/header/threeIcon03.png'
import threeIcon04 from '@/assets/images/header/threeIcon04.png'

import first_nav_icon01 from '@/assets/images/header/first_nav_icon01.svg';
import first_nav_icon02 from '@/assets/images/header/first_nav_icon02.svg';
import first_nav_icon03 from '@/assets/images/header/first_nav_icon03.svg';
import first_nav_icon04 from '@/assets/images/header/first_nav_icon04.svg';
import first_nav_icon05 from '@/assets/images/header/first_nav_icon05.svg';
import first_nav_icon06 from '@/assets/images/header/first_nav_icon06.svg';
import first_nav_icon07 from '@/assets/images/header/first_nav_icon07.svg';


import first_nav_active01 from '@/assets/images/header/first_nav_active01.svg';
import first_nav_active02 from '@/assets/images/header/first_nav_active02.svg';
import first_nav_active03 from '@/assets/images/header/first_nav_active03.svg';
import first_nav_active04 from '@/assets/images/header/first_nav_active04.svg';
import first_nav_active05 from '@/assets/images/header/first_nav_active05.svg';
import first_nav_active06 from '@/assets/images/header/first_nav_active06.svg';
import first_nav_active07 from '@/assets/images/header/first_nav_active07.svg';

export const firstNavIconList = [
    first_nav_icon01.src,
    first_nav_icon02.src,
    first_nav_icon03.src,
    first_nav_icon04.src,
    first_nav_icon05.src,
    first_nav_icon06.src,
    first_nav_icon07.src,
];
export const firstActiveIconList = {
    0: first_nav_active01.src,
    1: first_nav_active02.src,
    2: first_nav_active03.src,
    3: first_nav_active04.src,
    4: first_nav_active05.src,
    5: first_nav_active06.src,
    6: first_nav_active07.src,
};


const commonPath = '/site/about/'

export const htmlSuffix = process.env.HTML_SUFFIX;
export const publicPath = process.env.PUBLIC_PATH;


const homeList = [
    {
        title: '首页',
        href: officialUrl,
        children: []
    },
]
export const productNavList = [{
    title: '办公协同',
    icon: secondIcon01.src,
    children: [
        {
            title: '统一门户',
            href: publicPath + '/workportal' + htmlSuffix,
        },
        {
            title: '消息中心',
            href: publicPath + '/messagecenter' + htmlSuffix,
        },
        {
            title: '即时通讯',
            href: publicPath + '/instant' + htmlSuffix,
        },
        {
            title: '团队空间',
            href: publicPath + '/teamspace' + htmlSuffix,
        },
        // {
        //     title: '会议协同',
        //     href: publicPath + '/workportal',
        // },
        {
            title: '文件协同',
            href: publicPath + '/filecollaborate' + htmlSuffix,
        },
        {
            title: '大组织通讯录',
            href: publicPath + '/largebook' + htmlSuffix,
        }
    ]
},
{
    title: '业务协同',
    icon: secondIcon02.src,
    children: [
        {
            title: '应用中心',
            href: publicPath + '/appcenter' + htmlSuffix,
        },
        {
            title: '机器人通道',
            href: publicPath + '/intelrobot' + htmlSuffix,
        },
        {
            title: '智能服务台',
            href: publicPath + '/intelservice' + htmlSuffix,
        },

        {
            title: '待办中心',
            href: publicPath + '/todocenter' + htmlSuffix,
        },
        // {
        //     title: '流程中心',
        //     href: publicPath + '/largebook',
        // },
        // {
        //     title: '表单中心',
        //     href: publicPath + '/largebook',
        // }
    ]
},
{
    title: '业务融合',
    icon: secondIcon03.src,
    children: [
        {
            title: '低代码平台',
            href: publicPath + '/lowcodeplatform' + htmlSuffix,
        },
        {
            title: '小程序框架',
            href: publicPath + '/smallproframe' + htmlSuffix,
        },
        {
            title: '客户端SDK',
            href: publicPath + '/clientsdk' + htmlSuffix,
        },

        {
            title: 'H5应用集成',
            href: publicPath + '/appintegration' + htmlSuffix,
        },
        {
            title: '服务端API',
            href: publicPath + '/serverapi' + htmlSuffix,
        },
        // {
        //     title: '智能连接器',
        //     href: publicPath + '/largebook',
        // }
    ]
},

{
    title: '应用集市',
    icon: secondIcon04.src,
    children: [
        {
            title: '公众号',
            href: publicPath + '/publicaccount' + htmlSuffix,
        },
        {
            title: '投票问卷',
            href: publicPath + '/votequestion' + htmlSuffix,
        },
        {
            title: '日程',
            href: publicPath + '/teamsch' + htmlSuffix,
        },

        {
            title: '任务',
            href: publicPath + '/task' + htmlSuffix,
        },
        {
            title: '工作圈',
            href: publicPath + '/workingring' + htmlSuffix,
        },
        {
            title: '电子公告',
            href: publicPath + '/announcement' + htmlSuffix,
        },
        {
            title: '会议预定',
            href: publicPath + '/meeting' + htmlSuffix,
        },

    ]
},
{
    title: '安全保密',
    icon: secondIcon05.src,
    children: [
        {
            title: '明暗水印',
            href: publicPath + '/watermark' + htmlSuffix,
        },
        {
            title: '文件不落地',
            href: publicPath + '/filehang' + htmlSuffix,
        },
        {
            title: '高密低流管控',
            href: publicPath + '/highlowcontrol' + htmlSuffix,
        },

        {
            title: '远程擦除',
            href: publicPath + '/farerasure' + htmlSuffix,
        },
        {
            title: 'APP加固',
            href: publicPath + '/appreinforce' + htmlSuffix,
        },
        {
            title: '安全审计',
            href: publicPath + '/safeaudit' + htmlSuffix,
        }
    ]
},
{
    title: '可管可控',
    icon: secondIcon06.src,
    children: [
        {
            title: '高管模式',
            href: publicPath + '/leaderpattern' + htmlSuffix,
        },
        {
            title: '分级分权',
            href: publicPath + '/ranklimits' + htmlSuffix,
        },
        {
            title: '运营分析',
            href: publicPath + '/operationana' + htmlSuffix,
        },
        {
            title: '运维平台',
            href: publicPath + '/operationspla' + htmlSuffix,
        },
        {
            title: '审计平台',
            href: publicPath + '/auditplatform' + htmlSuffix,
        },
        {
            title: '应用审核',
            href: publicPath + '/applicationaudit' + htmlSuffix,
        },
        {
            title: '设备管控',
            href: publicPath + '/equipmentcontrol' + htmlSuffix,
        }
    ]
},
]
const productPcNav = [{
    title: '产品功能',
    threeRank: true,
    colSpan: 4,
    children: productNavList
}]
const resolvePcNav = [{
    title: '解决方案',
    threeRank: true,
    colSpan: 6,
    children: [
        {
            title: '产品解决方案',
            icon: threeIcon01.src,
            children: [
                {
                    title: '数字化办公平台',
                    href: publicPath + '/numberwork' + htmlSuffix,
                },
                {
                    title: '统一门户平台',
                    href: publicPath + '/unifiedportal' + htmlSuffix,
                },
                {
                    title: '即时通讯平台',
                    href: publicPath + '/instantplatform' + htmlSuffix,
                },
                {
                    title: '低代码开发平台',
                    href: publicPath + '/lowcode' + htmlSuffix,
                },
                {
                    title: 'SDK解决方案',
                    href: publicPath + '/sdk' + htmlSuffix,
                },
                {
                    title: '小程序解决方案',
                    href: publicPath + '/smallprogram' + htmlSuffix,
                }
            ]
        },
        {
            title: '党政军领域',
            icon: threeIcon02.src,
            children: [
                {
                    title: '城市',
                    href: `${publicPath}/government/city${htmlSuffix}`,
                },
                {
                    title: '政务',
                    href: `${publicPath}/government/affairs${htmlSuffix}`,
                },
                // {
                //     title: '应急',
                //     href: publicPath + '/government' + htmlSuffix + '?id=3',
                // },
                {
                    title: '纪检',
                    href: `${publicPath}/government/inspection${htmlSuffix}`,
                },
                {
                    title: '税务',
                    href: `${publicPath}/government/taxation${htmlSuffix}`,
                },
                {
                    title: '水务',
                    href: `${publicPath}/government/water${htmlSuffix}`,
                },
                // {
                //     title: '军队',
                //     href: publicPath + '/government' + htmlSuffix + '?id=7',
                // }
            ]
        },
        {
            title: '央国企领域',
            icon: threeIcon03.src,
            children: [
                {
                    title: '银行',
                    href: `${publicPath}/centerenterprise/bank${htmlSuffix}`,
                },
                {
                    title: '保险',
                    href: `${publicPath}/centerenterprise/insurance${htmlSuffix}`,
                },
                // {
                //     title: '资产管理',
                //     href: publicPath + '/centerenterprise' + htmlSuffix + '?id=3',
                // },
                {
                    title: '航司',
                    href: `${publicPath}/centerenterprise/airline${htmlSuffix}`,
                },
                {
                    title: '机场',
                    href: `${publicPath}/centerenterprise/airport${htmlSuffix}`,
                },
                {
                    title: '军工',
                    href: `${publicPath}/centerenterprise/warindustry${htmlSuffix}`,
                },
                {
                    title: '能源',
                    href: `${publicPath}/centerenterprise/energy${htmlSuffix}`,
                },
                {
                    title: '高端制造',
                    href: `${publicPath}/centerenterprise/highmake${htmlSuffix}`,
                }
            ]
        },
        {
            title: '教科文卫领域',
            icon: threeIcon04.src,
            children: [
                // {
                //     title: '教育',
                //     href: publicPath + '/teachscience' + htmlSuffix + '?id=1',
                // },
                {
                    title: '科研机构',
                    href: publicPath + '/teachscience/research' + htmlSuffix,
                },
                {
                    title: '医疗',
                    href: publicPath + '/teachscience/medical' + htmlSuffix,
                }
            ]
        },
    ]
}]
const productNav = [

    {
        title: '产品功能',
        children: [
            {
                title: '统一门户',
                href: publicPath + '/workportal' + htmlSuffix,
            },
            {
                title: '即时通讯',
                href: publicPath + '/instant' + htmlSuffix,
            },
            {
                title: '团队空间',
                href: publicPath + '/teamspace' + htmlSuffix,
            },
            {
                title: '消息中心',
                href: publicPath + '/messagecenter' + htmlSuffix,
            },
            {
                title: '应用中心',
                href: publicPath + '/appcenter' + htmlSuffix,
            },
            {
                title: '统一待办',
                href: publicPath + '/todocenter' + htmlSuffix,
            },
            // {
            //     title: '管理中心',
            //     href: publicPath + '/ranklimits' + htmlSuffix,
            // },

            // {
            //     title: '统一门户',
            //     href: officialUrl + commonPath + 'workportal.html',
            // },
            // {
            //     title: '即时通讯',
            //     href: officialUrl + commonPath + 'instant.html',
            // },
            // {
            //     title: '消息中心',
            //     href: officialUrl + commonPath + 'message.html',
            // },
            // {
            //     title: '应用中心',
            //     href: officialUrl + commonPath + 'appcenter.html',
            // },
            // {
            //     title: '统一待办',
            //     href: officialUrl + commonPath + 'dealt.html',
            // },
            // {
            //     title: '管理中心',
            //     href: officialUrl + commonPath + 'manage.html',
            // },
        ]
    }]

const resolveNav = [{
    title: '解决方案',
    children: [
        {
            title: '产品解决方案',
            href: publicPath + '/numberwork' + htmlSuffix,
        },
        {
            title: '党政军领域',
            href: `${publicPath}/government/city${htmlSuffix}`,
        },
        {
            title: '央国企领域',
            href: `${publicPath}/centerenterprise/bank${htmlSuffix}`,
        },
        {
            title: '教科文卫领域',
            href: publicPath + '/teachscience/research' + htmlSuffix,
        }
    ]
}]
const serviceNav = [
    {
        title: '服务中心',
        children: [

            {
                title: '在线客服',
                href: onlineServiceUrl,
            },

            {
                title: '客户服务',
                href: officialUrl + commonPath + 'service.html',
            },
            {
                title: '生态合作',
                href: officialUrl + commonPath + 'cooper.html',
            },
            {
                title: '开放平台文档',
                href: openPlatformUrl,
            }
        ]
    }
]
const contactChildren = [
    {
        title: '公司介绍',
        href: publicPath + '/about/company' + htmlSuffix,
    },
    {
        title: '荣誉资质',
        href: publicPath + '/about/honor' + htmlSuffix,
    },
    {
        title: '客户服务',
        href: publicPath + '/about/service' + htmlSuffix,
    },
    {
        title: '生态合作',
        href: publicPath + '/about/cooper' + htmlSuffix,
    },
]
const contactNav: any = [
    {

        title: '关于我们',
        id: 'about',
        children: contactChildren
    },
]




export const headerNavOut = (type?: string) => {
    let mobileNav: any[] = [
        ...productNav,
        ...resolveNav,
    ]
    if (type === 'pc') {
        mobileNav = [
            ...productPcNav,
            //...resolveNav
            ...resolvePcNav,
        ]
    }
    return [
        ...homeList,
        // {
        //     title: '优势特色',
        //     href: officialUrl + commonPath + 'advantage.html',
        //     children: []
        // },
        ...mobileNav,
        {
            title: '信创专题',
            href: publicPath + '/xinchuang' + htmlSuffix,
            children: []
        },
        {
            title: '新闻中心',
            href: officialUrl + '/new/',
            children: []
        },
        {
            title: '开放平台',
            href: openPlatformUrl,
            children: []
        },
        {
            title: '关于我们',
            id: 'about',
            children: [
                ...contactChildren,
                {
                    title: '在线客服',
                    href: onlineServiceUrl,
                }
            ]
        },
    ]
}

export const footerNavList = [
    ...productNav,
    ...resolveNav,
    ...serviceNav,
    ...contactNav
]

export const concatInfo = {
    title: "联系我们",
    list: [
        {
            tit: '市场合作',
            content: 'ccwork@360.cn',
            href: 'mailto:ccwork@360.cn'
        },
        {
            tit: '客服热线',
            href: 'tel:4001022518',
            content: '400 102 2518'
        },
        {
            tit: '北京地址',
            content: '北京市朝阳区酒仙桥路6号院360大厦'
        },
        {
            tit: '上海地址',
            content: '上海市普陀区曹杨路535号汇融大厦8层'
        },
    ]
}


export const friendLinkList = [{
    title: '360集团',
    url: 'https://www.360.cn/'
}, {
    title: '360网址导航',
    url: 'https://hao.360.com/'
}, {
    title: '企业网盘',
    url: 'https://www.fangcloud.com/'
}]


